<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="围栏类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择围栏类型">
                    <el-option v-for="item in typeOptions" :key="item.key" :label="item.label" :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="围栏范围" prop="fw">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" placeholder="单击绘制按钮后开始绘制,系统会自动闭合首尾坐标"
                    v-model="ruleForm.fw"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="drawLine">绘制</el-button>
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">创建</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { createFence } from "@/api/fence/index.js"
import DrawPolyline from "@/utils/cesiumBD/plot/DrawPolyline.js"
let DrawPolylineUti = undefined;
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [{
                key: 1,
                label: '禁入'
            }, {
                key: 2,
                label: '禁出'
            }],
            ruleForm: {
                type: "",
                fw: ""
            },
            rules: {
                type: [
                    { required: true, message: "请选择围栏类型", trigger: "change" },
                ],
                fw: [
                    { required: true, message: "请绘制围栏范围", trigger: "blur" }
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    createFence(this.ruleForm).then(() => {
                        this.$message({
                            message: "添加成功",
                            type: "success",
                        });
                        this.$bus.$emit("fence-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            DrawPolylineUti && DrawPolylineUti.clear();
            this.$refs[formName].resetFields();
        },
        getPlot(plot) {
            var keyPos = plot.attrPlot['edit_positions'];
            console.log(keyPos);
            if (keyPos.length < 1) {
                return;
            }
            var arr = [];
            //"[1.1,1.12],[1.3,1.33],[1.5,1.55]"
            for (let i = 0; i < keyPos.length; i++) {
                var lonlat = DrawPolylineUti.cartesianToLatlng(keyPos[i]);
                arr.push(`[${lonlat[0]},${lonlat[1]}]`);
            }
 
            var first=DrawPolylineUti.cartesianToLatlng(keyPos[0]);
            arr.push(`[${first[0]},${first[1]}]`);

            this.ruleForm.fw = arr.join(',');

            console.log(this.ruleForm);
        },
        drawLine() {
            if (!DrawPolylineUti) {
                DrawPolylineUti = new DrawPolyline({
                    canEdit: true,
                    callback: this.getPlot
                });
            }

            DrawPolylineUti.reset();
            DrawPolylineUti.start();
        }
    },
    created() {
    },
    mounted() { },
    beforeDestroy() {
        this.$refs['ruleForm'].resetFields();
        DrawPolylineUti && DrawPolylineUti.clear();
        DrawPolylineUti=undefined;
    }
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>